import { BaseAPI } from "@/api/baseAPI";
import apiClient from "@/api/apiClient";
import { extractApiData } from "@/utils/apiResponseHandler";
import type { Organisation, BranchArea } from "@/types";

class OrganisationAPI extends BaseAPI<Organisation> {
  constructor() {
    super("organisation");
  }

  async fetchBranchAreas(): Promise<BranchArea[]> {
    return await apiClient
      .get(`${this.model}/areas`)
      .then(extractApiData);
  }

  async fetchLogoById(id: number): Promise<Pick<Organisation, 'logo'>> {
    return await apiClient
      .get(`${this.model}/${id}/logo`)
      .then(extractApiData);
  }
}

export default new OrganisationAPI();
